import { FileInput } from './FileInput'
import { FormFileInput } from './FormFileInput'

export { FileInput, FormFileInput }
